import { Form, Icon, List, Popup, Radio } from "semantic-ui-react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { getReadableClientName } from "../../../libs/common_utils";
import { Config } from "../../../config/api";
import { walmartMXTranslations } from "../../../translations/walmartMXTranslations";

const tooltipDbaEnglish =
  'Dynamic Budget Allocation (DBA): An algorithm for automatically distributing and adjusting advertising budgets among different strategies within a campaign. Its objective is to optimize performance and spending pacing in real time, both at the macro level (daily allocations per strategy) and at the micro level (impression-by-impression pricing adjustments). \n\n' +
  'DBA allows advertisers to maximize the efficient use of their total available budget by dynamically adapting to market behavior, impression delivery, and the performance of each strategy, without the need for constant manual adjustments. If a manual daily spending and/or impression limit is defined, Dynamic Budget Allocation will adjust the strategic pacing amounts accordingly. Subject to an additional fee of $0.15 CPM (USD) included in the final effective CPM. The DBA fee is found under the "DBA Fee" metric in the "Performance Report."'

const DbaComponent = ({ onChange, values, disabled = false }) => {
  const intl = useIntl();

  return (
    <Form.Group>
      <Form.Field inline disabled={disabled}>
        <label>
          {intl.formatMessage({
            id: "LABEL_DBA",
            defaultMessage: "Dynamic Budget Allocation (DBA)",
          })}
          {
            <Popup
              inverted
              wide="very"
              size="small"
              trigger={
                <Icon
                  name="help circle"
                  style={{ position: "relative", fontSize: "1rem" }}
                  className="cursor-help"
                />
              }
            >
              <Popup.Content style={{ whiteSpace: "pre-line" }}>
                {
                  getReadableClientName(Config.public_client).toLowerCase() === "walmart"
                    ? walmartMXTranslations.tooltipDbaSpanish
                    : intl.formatMessage({
                      id: "TOOLTIP_DBA",
                      defaultMessage: tooltipDbaEnglish,
                    })
                }
              </Popup.Content>
            </Popup>
          }
        </label>
        <Radio
          name="dba"
          label={intl.formatMessage({
            id: "DBA_ON",
            defaultMessage: "On",
          })}
          value={1}
          checked={Boolean(values.dba)}
          onChange={onChange}
        />
        <Radio
          style={{ "marginLeft": "15px" }}
          name="dba"
          label={intl.formatMessage({
            id: "DBA_OFF",
            defaultMessage: "Off",
          })}
          value={0}
          checked={!Boolean(values.dba)}
          onChange={onChange}
        />
      </Form.Field>
    </Form.Group>
  );
};

DbaComponent.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

export default DbaComponent;
